import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type {
  ReportStepsQuery,
  StepsAvailabilityResponse
} from '@eggplant/types'

interface Props {
  params?: ReportStepsQuery
  onSuccess?: (data: StepsAvailabilityResponse) => void
  children?: (data: StepsAvailabilityResponse) => ReactElement
}

const GetAiAvailabilityRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/reports/availability/steps`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiAvailabilityRequest
